var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"galleryList",staticClass:"gallery"},_vm._l((_vm.addedAdvertising),function(picture,i){return _c('ItemCard',{key:("pictures-" + i + "-" + (picture.code)),attrs:{"item":picture,"multi-author":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }